import Vue from 'vue';
import Router from 'vue-router';
import vueSmoothScroll from 'vue2-smooth-scroll';
import store from './store';
import { applyRouteMeta } from './seo-meta';
import { PUBLIC_ROUTES, TOKEN_ROUTES } from '../server/seo/routes-meta';

import landingPage from './components/landing/landing.vue';
import registerPage from './components/register/register-layout.vue';
import registerUserPage from './components/register/register-user-form.vue';
import restorePasswordPage from './components/register/restore-password.vue';
import restoreChangePasswordPage from './components/register/restore-change-password.vue';
import confirmEmaildPage from './components/register/confirm-email.vue';
import confirmRecoveryEmailPage from './components/register/confirm-recovery-email.vue';

// Las rutas se definen en routes-meta.js; acá solo se asigna su componente.
const PAGES = {
    '/': landingPage,
    '/registro': registerPage,
    '/recuperar-clave': restorePasswordPage,
    '/contactos': () => import('./components/info/contacts.vue'),
    '/preguntas-frecuentes': () => import('./components/info/faqs.vue'),
    '/registro-usuario': registerUserPage,
    '/nueva-clave': restoreChangePasswordPage,
    '/confirmar-correo': confirmEmaildPage,
    '/cambiar-correo-recuperacion': confirmRecoveryEmailPage,
};

const routes = [
    ...PUBLIC_ROUTES.map(({ path }) => ({ path, component: PAGES[path] })),
    ...TOKEN_ROUTES.map(({ prefix }) => ({ path: `${prefix}/:token?`, component: PAGES[prefix], props: true })),
    { path: '*', component: () => import('./components/utils/not-found.vue') },
];

Vue.use(vueSmoothScroll);
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) return savedPosition;

        if (to.hash || to.path === from.path) return false;

        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    const isLeavingRegisterRoute = from.path === '/registro' && to.path !== '/registro';

    if (isLeavingRegisterRoute) {
        store.dispatch('clearSharedComponentsInfo');
    }

    next();
});

router.afterEach(to => {
    applyRouteMeta(to);
});

export default router;
